import { API_URL, jwtToken } from "../../../context/appContext";
export default async function cancelOrder(id, recreate = true, cancelAll = false, botId) {

    return fetch(`${API_URL}/api/order_process/${id}/${botId}/cancel?recreate=${recreate}&cancelAll=${cancelAll}`, {
        method: "GET",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + jwtToken
        }
    })
        .then(res => res.json())
        .then(res => res)
        .catch(err => err)
}
